import BaseService from "@/boot/BaseService";
class IngenieriaService extends BaseService {
    constructor() {
        super(null, "/ingenierias");
    }
    async grid(params) {
        return await this.get("/grid", params);
    }
    async store(formData) {
        return await this.post("", formData);
    }

    async show(id) {
        return await this.get(`/${id}`);
    }

    async importar(ingenieriaId, file) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('ingenieria_id', ingenieriaId);
        return await this.post("/import", formData);
    }

    async confirmaImport(formData) {
        return await this.post("/confirma-import", formData);
    }

    async desglocePresupuesto(payload) {
        return await this.post("/desgloce-presupuesto", payload);
    }

    async agregaProductosDesglozados(payload) {
        return await this.post("/agrega-productos-desglozados", payload);
    }
}

export default new IngenieriaService();
